import { useEffect } from 'react';
import { useIntl } from 'react-intl';

interface Options {
  separator?: string;
  shouldUseAppNameSuffix?: boolean;
}

const appTitleIntlId = 'appName';
const defaultSeparator = ' - ';

// Usage of this hook must not overlap on the same document,
// it should only be active in a single rendering component
export const useLocalizedDocumentTitle = (
  titlePartIntlIds: string[] | string,
  options: Options = {},
) => {
  const intl = useIntl();
  const { separator = defaultSeparator, shouldUseAppNameSuffix = false } = options;

  useEffect(() => {
    const allParts = Array.isArray(titlePartIntlIds) ? [...titlePartIntlIds] : [titlePartIntlIds];
    if (shouldUseAppNameSuffix) {
      allParts.push(appTitleIntlId);
    }

    document.title = allParts
      .filter((translationId) => translationId)
      .map((id) => intl.formatMessage({ id }))
      .join(separator);
  }, [titlePartIntlIds, separator, intl, shouldUseAppNameSuffix]);
};
